import ErrorNotifier from 'app/scripts/services/error-notifier';
import { TDispatch } from 'state';
import { fetchTeam } from '../../api';
import { TModerationUser } from './../../../moderation-v2/users/state/types';
import {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure
} from './../../../moderation-v2/users/state/actions';

const fetchTeamMembers = () => {
  return async (dispatch: TDispatch) => {
    dispatch(fetchUsersStart({ type: TModerationUser.TeamMembers }));

    try {
      const response = await fetchTeam();
      const { users } = parse(response);
      dispatch(fetchUsersSuccess({ users, type: TModerationUser.TeamMembers }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to fetch team members`);
      dispatch(fetchUsersFailure({ type: TModerationUser.TeamMembers }));
    }
  };
};

function parse(data) {
  return {
    ...data,
    users: (data.users || []).map(user => ({
      isBlacklisted: user.blacklisted,
      displayName: user.display_name,
      id: user.id,
      imageId: user.image_id,
      isOnline: user.online,
      isRegistered: user.registered,
      roles: user.roles,
      username: user.user_name,
      isWhitelisted: user.whitelisted,
      email: user.email
    }))
  };
}
export default fetchTeamMembers;
